import { render } from "./AgentExtensionReportPage.vue?vue&type=template&id=207a17ca&ts=true"
import script from "./AgentExtensionReportPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentExtensionReportPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/reports/agent-extension/AgentExtensionReportPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "207a17ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('207a17ca', __exports__)) {
    api.reload('207a17ca', __exports__)
  }
  
  module.hot.accept("./AgentExtensionReportPage.vue?vue&type=template&id=207a17ca&ts=true", () => {
    api.rerender('207a17ca', render)
  })

}


export default __exports__